<template>
    <AppLayout :contrast="true" title="Editar código postal">
        <Breadcrumb
            name="Códigos postales"
            routeName="cps"
            page="Editar codigo postal"
        />

        <form class="p-2">
            <div class="flex flex-col lg:flex-row lg:w-full">
                <div
                    class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:w-1/2"
                >
                    <div class="font-medium text-gray-600 text-lg mb-2">
                        Datos básicos
                    </div>
                    <div class="flex flex-col h-24">
                        <label for="cp" class="my-1 text-gray-700">
                            Codigo postal<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="number"
                            arrow
                            id="cp"
                            :class="[
                                't-input',
                                form.errors.cp && 't-input-invalid',
                            ]"
                            v-model="form.cp"
                            autofocus
                            required
                            @focus="form.errors.cp = null"
                        />
                        <small
                            v-if="form.errors.cp"
                            id="cp-help"
                            class="p-error"
                        >
                            {{ form.errors.cp }}
                        </small>
                    </div>

                    <div class="flex flex-col h-24">
                        <label for="localidad" class="my-1 text-gray-700">
                            Localidad<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="localidad"
                            :class="[
                                't-input',
                                form.errors.localidad && 't-input-invalid',
                            ]"
                            v-model="form.localidad"
                            required
                            @focus="form.errors.localidad = null"
                        />
                        <small
                            v-if="form.errors.localidad"
                            id="localidad-help"
                            class="p-error"
                        >
                            {{ form.errors.localidad }}
                        </small>
                    </div>

                    <div class="flex flex-col h-24">
                        <label for="provincia" class="my-1 text-gray-700">
                            Provincia<span class="text-red-400">*</span>
                        </label>
                        <input
                            type="text"
                            id="provincia"
                            :class="[
                                't-input',
                                form.errors.provincia && 't-input-invalid',
                            ]"
                            v-model="form.provincia"
                            required
                            @focus="form.errors.provincia = null"
                        />
                        <small
                            v-if="form.errors.provincia"
                            id="provincia-help"
                            class="p-error"
                        >
                            {{ form.errors.provincia }}
                        </small>
                    </div>

                    <div class="flex flex-col h-24">
                        <label for="cordon_id" class="my-1 text-gray-700"
                            >Cordon<span class="text-red-400">*</span></label
                        >
                        <select
                            id="cordon_id"
                            class="t-select"
                            v-model="form.cordon_id"
                            required
                        >
                            <option selected="selected" disabled>
                                Seleccionar
                            </option>
                            <option
                                v-for="cordon in cordones"
                                :value="cordon.id"
                                :key="cordon.id"
                            >
                                {{ cordon.descripcion }}
                            </option>
                        </select>

                        <small
                            v-if="form.errors.cordon_id"
                            id="cordon_id-help"
                            class="p-error"
                        >
                            {{ form.errors.cordon_id }}
                        </small>
                    </div>
                </div>
            </div>
            <div class="m-4 flex justify-end">
                <Button @click.prevent="update"> Editar CP </Button>
            </div>
        </form>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";

export default {
    components: {
        AppLayout,
        Link,
        Icon,
        AngleRight,
        Breadcrumb,
        Button,
    },
    props: {
        cp: Object,
        cordones: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                cordon_id: this.cp.cordon_id,
                cp: this.cp.cp,
                localidad: this.cp.localidad,
                provincia: this.cp.provincia,
            }),
        };
    },
    methods: {
        update() {
            this.form.put("/cps/" + this.cp.id);
        },
    },
};
</script>

<style scoped>
.p-inputtext:enabled:focus,
.p-password-input:enabled:focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}
.p-inputtext:hover,
.p-password-input:hover {
    border-color: #829fc1;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>
